import Box from "ds/components/Box";
import TextEllipsis from "ds/components/TextEllipsis";
import Typography from "ds/components/Typography";

import { VariableCellComponentProps } from "./types";

const NameCell = ({ variable }: VariableCellComponentProps) => {
  return (
    <Box align="center">
      <TextEllipsis tooltip={variable.id} tooltipWidthMode="maxWidthSm">
        {(props) => (
          <Typography {...props} variant="p-body3" tag="span">
            {variable.id}
          </Typography>
        )}
      </TextEllipsis>
    </Box>
  );
};

export default NameCell;
